export default {
	AS: '#c5def5',
	AU: '#005495',
	CK: '#fae7b5',
	FJ: '#003d2d',
	FM: '#609fa0',
	GU: '#9f8170',
	KI: '#ffe4c4',
	MH: '#e0e3c2',
	MP: '#ffa91e',
	NC: '#ace5ed',
	NF: '#cb4154',
	NR: '#8a0303',
	NU: '#b5a642',
	NZ: '#0395b6',
	PF: '#609fa0',
	PG: '#601933',
	PN: '#536872',
	PW: '#d7ab80',
	SB: '#a3c1ad',
	TF: '#609fa0',
	TK: '#e4717a',
	TO: '#92a1cf',
	TV: '#e9692d',
	VU: '#4997d0',
	WF: '#efbbcc',
	WS: '#a67b5b',
	BN: '#c46112',
	CC: '#ffb294',
	CX: '#e42636',
	ID: '#a67a5b',
	KH: '#efdecd',
	LA: '#9f2c68',
	MM: '#ffbf00',
	MY: '#3b7956',
	PH: '#ff7e03',
	SG: '#3b3b6c',
	TH: '#804040',
	TL: '#cfcfcf',
	VN: '#a4c639',
	AF: '#494446',
	BD: '#3c8d0e',
	BT: '#aa0213',
	IN: '#7f1634',
	IO: '#cd607e',
	LK: '#fffdd0',
	MV: '#d2691e',
	NP: '#996666',
	PK: '#ff7f50',
	CN: '#a8ae68',
	HK: '#b283be',
	JP: '#6F8798',
	KP: '#80b3d8',
	KR: '#D5D3C7',
	MN: '#dc6963',
	MO: '#00308f',
	TW: '#648fb4',
	'Asia Pacific Region': '#0075cf',
	Oceania: '#054200',
	'Southern Asia': '#49a324',
	'Eastern Asia': '#5f175a',
	'South-Eastern Asia': '#f05204'
};
